module.exports = __webpack_public_path__ + "img/ruben.53bfc80f.png";